// TODO roles are per Organisation from v2

import store from '@/store';

function roleInMerchant(organisationId) {
  const merchantRoles = JSON.parse(localStorage.getItem('merchantRoles'));

  if (merchantRoles && merchantRoles.length) {
    let merchantRole = null;
    const targetOrganisation = merchantRoles.find(organisation => organisation.organisation_id === organisationId);
    if (targetOrganisation) {
      merchantRole = targetOrganisation.role;
    }
    return merchantRole;
  }

  return false;
}

function roleInCurrentOrganisation() {
  if (store.getters['organisation/me']) {
    return store.getters['organisation/me'].role;
  }

  return false;
}

export { roleInMerchant, roleInCurrentOrganisation };
